/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Sent when "distance within" UI is off so URL handlers clear the radius param
 * (same rule as slider "ALL": `distance[0] >= 1000` → no `distance` in search).
 */
export const PLACE_LIST_DISTANCE_UNLIMITED_FOR_APPLY: [number] = [1000]

/** Values shared by place list filter forms (URL-backed). */
export type PlaceListFilterFormValues = {
  name?: string
  distance: number[]
  tags: string[]
  categories: string[]
  location: { name?: string; longitude?: number; latitude?: number }
  myPlaces?: boolean
  needsReview?: boolean
  sortBy?: string
  /** RHF field for the read-only location placeholder row */
  locationPlaceholder?: string
}

/**
 * Sent when "distance from" UI is off so URL handlers clear starting location (`location`, `locationLat`, `locationLong`).
 */
export const PLACE_LIST_LOCATION_EMPTY_FOR_APPLY: PlaceListFilterFormValues['location'] = {}

/** Build filter form values from route-resolved search + profile (matches `useFixedParams` + list defaults). */
export function placeListFilterFormValuesFromResolvedParams(params: {
  name?: string
  distance?: number
  tags?: string[]
  categories?: string[]
  location?: string
  locationLat?: number
  locationLong?: number
  sortBy?: string
  myPlaces: boolean
  needsReview: boolean
}): PlaceListFilterFormValues {
  return {
    name: params.name ?? '',
    distance: [params.distance ?? 10_000],
    tags: params.tags ?? [],
    categories: params.categories ?? [],
    location: {
      name: params.location,
      longitude: params.locationLong,
      latitude: params.locationLat,
    },
    myPlaces: params.myPlaces,
    needsReview: params.needsReview,
    locationPlaceholder: '',
    sortBy: params.sortBy,
  }
}
